import { apiFetch } from '../utils/apiFetch'

export interface LegalStatus {
  needsAcceptance: boolean;
  tosVersion: string;
  privacyVersion: string;
  acceptedTosVersion: string | null;
  acceptedPrivacyVersion: string | null;
}

export interface LegalContent {
  content: string;
  version: string;
}

export const legalService = {
  async getStatus(): Promise<LegalStatus> {
    const token = localStorage.getItem('lts_jwt_token')
    const res = await apiFetch('/api/legal/status', {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    })
    const payload = await res.json().catch(() => ({}))
    if (!res.ok || payload?.success === false) {
      throw new Error(payload?.message || 'Failed to fetch legal status')
    }
    return {
      needsAcceptance: !!payload?.needsAcceptance,
      tosVersion: String(payload?.tosVersion || ''),
      privacyVersion: String(payload?.privacyVersion || ''),
      acceptedTosVersion: payload?.acceptedTosVersion ?? null,
      acceptedPrivacyVersion: payload?.acceptedPrivacyVersion ?? null,
    }
  },

  async accept(tosVersion: string, privacyVersion: string): Promise<void> {
    const token = localStorage.getItem('lts_jwt_token')
    const res = await apiFetch('/api/legal/accept', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ tosVersion, privacyVersion }),
    })
    const payload = await res.json().catch(() => ({}))
    if (!res.ok || payload?.success === false) {
      throw new Error(payload?.message || 'Failed to accept legal documents')
    }
  },

  async getContent(type: 'tos' | 'privacy'): Promise<LegalContent> {
    const token = localStorage.getItem('lts_jwt_token')
    const res = await apiFetch(`/api/legal/content?type=${encodeURIComponent(type)}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    })
    const payload = await res.json().catch(() => ({}))
    if (!res.ok || payload?.success === false) {
      throw new Error(payload?.message || 'Failed to fetch legal content')
    }
    return {
      content: String(payload?.content || ''),
      version: String(payload?.version || ''),
    }
  },
};
